import { ECardType } from '__generated__/globalTypes';
import { CreateGuideStoryVariables } from 'graphql/mutation/__generated__/CreateGuideStory';
import { GuideQuery_guide_stories } from 'graphql/query/__generated__/GuideQuery';

const importKeyColumn = 'Company name';

const SOCIALS = [
    'Facebook',
    'Instagram',
    'LinkedIn',
    'Twitter',
    'YouTube',
    'TikTok',
    'Snapchat',
    'Pinterest',
    'Twitch'
];

function parser(guideId: string, row: Record<string, string>): CreateGuideStoryVariables {
    function getLogo() {
        const str = row['Logo1']?.trim();

        if (!str) {
            return undefined;
        }

        const imageId = str
            .replace('https://drive.google.com/open?id=', '')
            .replace('&usp=drive_copy', '')
            .trim();
        const imageUrl = 'https://drive.google.com/uc?id=' + imageId;

        return imageUrl;
    }

    const mutationPayload: CreateGuideStoryVariables = {
        guideId,
        story: {
            importKey: row[importKeyColumn],
            header: {
                title: row['Company name'],
                text: row['Description of the company'],
                imageUrl: getLogo()
            }
        },
        cards: []
    };

    if (row['Internship opportunity']) {
        mutationPayload.cards.push({
            type: ECardType.TEXT,
            info: {
                title: 'Sommerjobb muligheter',
                description: row['Internship opportunity']
            }
        });
    }

    if (row['M.Sc thesis opportunities']) {
        mutationPayload.cards.push({
            type: ECardType.TEXT,
            info: {
                title: 'Masteroppgave muligheter',
                description: row['M.Sc thesis opportunities']
            }
        });
    }

    if (
        row['Region of offices'] ||
        row['Revenue'] ||
        row['Number of employees'] ||
        row['When was the company founded']
    ) {
        let text = '';

        if (row['Region of offices']) {
            text += `**Region dere har kontor i**: ${row['Region of offices']}\n`;
        }
        if (row['Revenue']) {
            text += `**Omsetning**: ${row['Revenue']}\n`;
        }
        if (row['Number of employees']) {
            text += `**Antall ansatte**: ${row['Number of employees']}\n`;
        }
        if (row['When was the company founded']) {
            text += `**Stiftelsesår**: ${row['When was the company founded']}\n`;
        }

        mutationPayload.cards.push({
            type: ECardType.TEXT,
            info: {
                title: 'Bedriftsinformasjon',
                description: text
            }
        });
    }

    if (
        row['Name for company representative'] ||
        row['Email'] ||
        row['Phone number for company representative']
    ) {
        let text = '';

        if (row['Name for company representative']) {
            text += `**Navn til kontaktperson**: ${row['Name for company representative']}\n`;
        }
        if (row['Email']) {
            text += `**Email**: ${row['Email']}\n`;
        }
        if (row['Phone number for company representative']) {
            text += `**Tlf nummer**: ${row['Phone number for company representative']}\n`;
        }

        mutationPayload.cards.push({
            type: ECardType.TEXT,
            info: {
                title: 'Kontakt',
                description: text
            }
        });
    }

    if (row['Home page url'] || row['Social media url']) {
        mutationPayload.cards.push({
            type: ECardType.LINK,
            links: [
                ...(row['Home page url']
                    ? row['Home page url']
                          .split('\n')
                          .map((e) => e.trim())
                          .filter(Boolean)
                          .map((e) => ({
                              title: 'Hjemmeside',
                              url: e
                          }))
                    : []),
                ...(row['Social media url']
                    ? row['Social media url']
                          .split('\n')
                          .map((e) => e.trim())
                          .filter(Boolean)
                          .map((e) => ({
                              title:
                                  SOCIALS.find((s) => e.toLowerCase().includes(s.toLowerCase())) ??
                                  'SoMe',
                              url: e
                          }))
                    : [])
            ]
        });
    }

    function getPicture() {
        const str = row['Cool pictures from your operations']?.trim();

        if (!str) {
            return undefined;
        }

        const imageId = str
            .replace('https://drive.google.com/open?id=', '')
            .replace('&usp=drive_copy', '')
            .trim();
        const imageUrl = 'https://drive.google.com/uc?id=' + imageId;

        return imageUrl;
    }

    if (row['Cool pictures from your operations1'] && getPicture()) {
        mutationPayload.cards.push({
            type: ECardType.IMAGE,
            images: [
                {
                    imageUrl: getPicture()
                }
            ]
        });
    }

    return mutationPayload;
}

function duplicateChecker(story: GuideQuery_guide_stories, row: Record<string, string>): boolean {
    return story.importKey?.toLowerCase() === row[importKeyColumn]?.toLowerCase();
}

export const bm2024ImportMethods = { duplicateChecker, parser, importKeyColumn };
